export default __webpack_public_path__ + "static/media/houimg4.cb9fe32f.webp";